// Korean project translations keyed by project id (fallback: English in portfolio.js)
export const PROJECTS_KO = {
  "nerget-integration": {
    title: "LG U+ Nerget BSS 통합",
    category: "통신 BSS",
    description: "Compax Digital의 엔터프라이즈 BSS 플랫폼과 LG U+ Nerget 시스템을 통합했습니다 — Java Spring(JSF & Hibernate JPA)과 PostgreSQL로 두 플랫폼 간 가입자 관리, 과금, 서비스 프로비저닝 흐름을 처리했습니다.",
    challenge: "LG U+ Nerget 플랫폼과 Compax 엔터프라이즈 BSS가 각각 가입자 및 과금 데이터를 독립적으로 관리하고 있어, 수동 정산 없이 계정·서비스·청구서를 동기화하는 견고한 통합 계층이 필요했습니다.",
    approach: "JSF 화면과 PostgreSQL 위 Hibernate JPA 영속 계층을 갖춘 Java Spring으로 통합 계층을 구축하고, Nerget 데이터 모델을 Compax BSS 엔티티에 매핑했습니다. LG U+ 스테이징 환경에서 가입자·과금·프로비저닝 흐름을 엔드투엔드로 검증했습니다.",
    outcome: "Compax BSS와 Nerget을 연결하는 통합이 운영 환경에 적용되어, 가입자 관리와 과금 데이터가 두 플랫폼 간에 자동으로 흐르게 되었습니다.",
  },
  "starhub-integration": {
    title: "StarHub BSS 통합",
    category: "통신 BSS",
    description: "싱가포르 StarHub 통신 시스템과 Compax Digital 엔터프라이즈 BSS 플랫폼을 통합하여, Java Spring(JSF & Hibernate JPA)과 PostgreSQL로 가입자·과금·서비스 관리 흐름을 제공했습니다.",
    challenge: "싱가포르 주요 통신사 StarHub는 Compax BSS 플랫폼이 가입자 온보딩, 과금 주기, 서비스 프로비저닝 전반에서 내부 통신 시스템과 연동되길 필요로 했으며, 엄격한 데이터 정합성 요구사항이 있었습니다.",
    approach: "JSF 인터페이스 계층과 PostgreSQL 위 Hibernate JPA로 Java Spring 통합 서비스를 개발하고, StarHub 엔지니어링 팀과 공동 테스트 주기를 통해 각 통합 흐름을 인증했습니다.",
    outcome: "StarHub 통합을 일정에 맞춰 성공적으로 제공하여, Compax BSS의 동남아 통신 시장 진출을 실현했습니다.",
  },
  hiddentag: {
    title: "HiddenTag 글로벌 플랫폼",
    category: "블록체인 & 보안",
    description: "인증, 커뮤니티, 리뷰, 마켓플레이스를 제공하는 글로벌 플랫폼의 백엔드 아키텍처를 설계했습니다. RESTful API와 데이터 계층을 구축하고, 운영 출시를 위해 Tomcat에서 AWS의 Docker 컨테이너로 배포를 마이그레이션했습니다.",
    challenge: "HiddenTag는 인증·커뮤니티·리뷰·마켓플레이스라는 4개의 distinct한 도메인을 하나의 글로벌 백엔드로 제공해야 했고, 기존 Tomcat 인프라는 릴리스를 느리고 위험하게 만들었습니다.",
    approach: "Spring Boot로 백엔드 아키텍처를 처음부터 설계하여 도메인 서비스를 분리하고 깔끔한 RESTful API를 제공했습니다. Hibernate JPA와 MyBatis, MySQL로 데이터 계층을 구축하고, 전체 배포를 AWS의 Docker로 컨테이너화했습니다.",
    outcome: "HiddenTag 글로벌 플랫폼이 일정에 맞춰 운영 출시되었고, 컨테이너화된 배포 파이프라인으로 이후 릴리스가 빠르고 안전하게 롤백 가능해졌습니다.",
  },
  "sehati-bahrain": {
    title: "SEHATI — 바레인 국가건강보험 시스템",
    category: "국가 헬스케어",
    description: "AWS에서 SEHATI 바레인 국가건강보험 시스템을 현대화했습니다 — JDK 7 → 8, Tomcat 7 → 9, Oracle RDS 12c → 19c 업그레이드를 바레인 왕국의 국가 건강보험 플랫폼에 적용했습니다.",
    challenge: "바레인 국가건강보험 시스템은 JDK 7, Tomcat 7, Oracle 12c의 노후 인프라에서 운영되며 보안 취약점과 유지보수 리스크가 누적되고 있었습니다. AWS가 구버전 Oracle의 강제 업그레이드를 발표하면서 긴급성이 높아졌고, LG CNS 매니저는 관리되지 않은 AWS 강제 업그레이드가 운영 시스템 호환성을 깨고 국가적 장애를 일으킬 수 있다고 판단했습니다. 여기에 알려진 보안 취약점도 해결이 필요했습니다.",
    approach: "AWS의 강제 업그레이드 일정에 끌려가는 대신 주도권을 잡았습니다: 운영 워크로드와의 호환성을 완전히 테스트하며 Oracle RDS 12c → 19c 단계적 마이그레이션을 계획·실행하고, 같은 프로그램에서 JDK 7 → 8, Tomcat 7 → 9 업그레이드를 진행했습니다. JavaScript → jQuery 프론트엔드 현대화는 범위를 정했지만 개발 기간과 계획이 더 필요하고 Oracle DB가 가장 시급한 문제였기에 의도적으로 연기했습니다.",
    outcome: "SEHATI가 AWS 강제 업그레이드 이전에 Oracle 19c, JDK 8, Tomcat 9로 무중단 마이그레이션되었습니다. 국가건강보험 시스템이 핵심 스택의 지원되는 안전한 버전에서 운영되며, 프론트엔드 현대화는 별도 후속 프로젝트로 계획되었습니다.",
  },
  gspostbox: {
    title: "차세대 GS Postbox 시스템",
    category: "물류 & 클라우드",
    description: "차세대 GS Postbox 플랫폼을 위해 GitOps / ArgoCD Kubernetes 환경에서 CI/CD 파이프라인과 배포 자동화를 구축했습니다.",
    challenge: "차세대 GS Postbox 시스템은 환경 전반에 빈번하고 안정적인 릴리스가 필요했지만, 배포가 수동이고 오류가 잦으며 감사가 어려웠습니다.",
    approach: "Kubernetes에 ArgoCD 기반 GitOps CI/CD 파이프라인을 설계하여, Git을 모든 환경의 단일 진실 소스로 만들고 커밋부터 클러스터까지 롤아웃을 자동화했습니다.",
    outcome: "배포가 완전히 자동화되고 감사 가능해졌으며, 선언적 롤백과 일관된 환경을 갖추게 되었습니다.",
  },
  lguplus: {
    title: "LG U+ 디지털 카탈로그 시스템",
    category: "통신 시스템",
    description: "Adobe AEM 프레임워크 기반 LG U+ 디지털 카탈로그 시스템에 커스텀 Maven 프로필을 통해 Jenkins CI/CD 파이프라인과 배포 자동화를 구축했습니다.",
    challenge: "LG U+ 디지털 카탈로그는 Adobe AEM에서 운영되며, 릴리스에 많은 수동 패키징 단계가 필요해 통신 상품 업데이트가 지연되었습니다.",
    approach: "Jenkins 기반 CI/CD 파이프라인을 구축하고 AEM 프레임워크에 맞춘 커스텀 Maven 프로필을 설계하여, 환경별 빌드·패키징·배포를 자동화했습니다.",
    outcome: "카탈로그 릴리스가 엔드투엔드로 자동화되어 배포 노력이 줄고, 콘텐츠와 상품 업데이트가 더 빠르게 운영 환경에 반영되게 되었습니다.",
  },
  shinhanbank: {
    title: "신한은행 — The Next Project",
    category: "코어 뱅킹",
    description: "신한은행 차세대 내부 관리 시스템을 위한 인터페이스 서비스(MCI / FEP / EAI 서비스 메시)를 관리·배포했습니다.",
    challenge: "신한은행 차세대 내부 시스템은 시스템 간 인터페이스(MCI / FEP / EAI)망에 의존하며, 잘못된 설정 하나가 코어 뱅킹 운영을 중단시킬 수 있었습니다.",
    approach: "환경 전반의 인터페이스 서비스 메시를 관리·배포하고, 릴리스를 조정하며 은행 내부 시스템 간 메시지 흐름을 검증했습니다.",
    outcome: "인터페이스 서비스가 프로젝트 전 기간 안정적으로 배포·운영되어, 미션 크리티컬한 내부 뱅킹 시스템의 연결을 유지했습니다.",
  },
  "korean-social-security": {
    title: "한국 사회보장정보 시스템",
    category: "공공 부문",
    description: "차세대 한국 사회보장정보 시스템을 위한 MyBatis 기반 Java Batch 서비스를 개발했습니다.",
    challenge: "국가 사회보장 시스템은 정해진 배치 윈도우 내에서 방대한 복지·자격 데이터를 처리하며, 실패가 허용되지 않습니다.",
    approach: "MyBatis로 Java Batch 서비스를 개발하고, 재시작 가능한 잡 구조와 대규모 관계형 스키마에 대한 정확한 데이터 매핑을 구현했습니다.",
    outcome: "차세대 시스템용 배치 서비스가 제공되어, 전국 사회보장 데이터를 요구되는 윈도우 내에서 안정적으로 처리합니다.",
  },
  middleblock: {
    title: "Middleblock 블록체인 플랫폼",
    category: "블록체인",
    description: "Middleblock 블록체인 플랫폼(Hyperledger Indy, Aries & Fabric)을 위한 Java Spring 통합 REST API 게이트웨이 서버를 개발하여 고객 애플리케이션의 쉬운 연동을 지원했습니다.",
    challenge: "Middleblock 플랫폼(Hyperledger Indy, Aries & Fabric)은 강력했지만 복잡한 블록체인 API로 인해 고객 애플리케이션이 직접 연동하기 어려웠습니다.",
    approach: "세 개의 Hyperledger 프레임워크를 단일하고 간단한 HTTP 인터페이스 뒤로 감싸는 Java Spring 통합 REST API 게이트웨이를 설계·개발했습니다.",
    outcome: "고객 애플리케이션이 친숙한 REST 호출로 블록체인 플랫폼에 온보딩할 수 있게 되어 연동 노력이 크게 줄었습니다.",
  },
  "yeosu-flagship": {
    title: "여수 데이터 플래그십 프로젝트",
    category: "빅데이터 & 스마트시티",
    description: "McKinley Rice 국제 엔지니어링 팀과 협업하여 빅데이터 웨어하우스 인프라와 모니터링 플랫폼을 설계·구현했습니다.",
    challenge: "여수 데이터 플래그십 프로젝트는 도시 규모의 데이터 스트림을 집계·분석해야 했지만, 이를 지원할 웨어하우스 인프라와 가시성 플랫폼이 없었습니다.",
    approach: "Hadoop, Spark, Hive로 빅데이터 웨어하우스를 설계·구현하고, Django 백엔드와 React 프론트엔드로 모니터링 플랫폼을 구축했습니다. McKinley Rice 국제 엔지니어링 팀과 협업했습니다.",
    outcome: "웨어하우스와 모니터링 플랫폼이 여수 스마트시티 데이터 이니셔티브의 플래그십 인프라로 제공되었습니다.",
  },
  "sensor-gateway": {
    title: "센서 게이트웨이 백엔드 마이그레이션",
    category: "IoT 게이트웨이",
    description: "메인 센서 게이트웨이 백엔드를 Go에서 Java Spring(TCP/IP 소켓, gRPC, REST API)으로 마이그레이션하고, 안정성과 확장성을 위해 Kafka 기반 데이터 파이프라인을 구현했습니다.",
    challenge: "핵심 센서 게이트웨이가 Go로 작성되어 조직이 유지보수·확장하기 어려웠고, 센서 데이터 파이프라인에 내구성 보장이 부족했습니다.",
    approach: "TCP/IP 소켓, gRPC, REST API 수집을 지원하는 Java Spring으로 게이트웨이를 재작성하고 Kafka 기반 파이프라인을 구현했으며, 이후 Apache Nifi와 Streamsets로 관리형 데이터 흐름을 업그레이드했습니다.",
    outcome: "마이그레이션된 게이트웨이는 데이터 안정성과 확장성을 개선했으며, 코드베이스를 팀의 Java 전문성에 맞췄습니다.",
  },
  "goseong-sacheon": {
    title: "고성 & 사천 IoT 대시보드",
    category: "스마트시티",
    description: "고성 및 사천 지자체를 위한 관광 센서 IoT 대시보드를 실시간 텔레메트리 시각화와 함께 개발했습니다.",
    challenge: "고성과 사천 지자체는 관광 센서를 배포했지만 수집되는 데이터를 보고 활용할 방법이 없었습니다.",
    approach: "React 프론트엔드, Java Spring 백엔드, MariaDB 저장소로 풀스택 대시보드를 개발하여, 실시간 관광 센서 텔레메트리를 시각화했습니다.",
    outcome: "두 지자체가 관광 흐름과 센서 상태를 실시간으로 파악하게 되어, 원시 IoT 데이터를 활용 가능한 인사이트로 전환했습니다.",
  },
  "micube-ai": {
    title: "MICUBE AI 시각화 도구",
    category: "AI 분석",
    description: "KISA 정부 프로젝트를 위한 AI 시각화 대시보드를 실시간 분석 및 차트와 함께 개발했습니다.",
    challenge: "KISA는 AI 모델 출력과 보안 분석을 비기술 정부 이해관계자가 이해할 수 있게 만들 방법이 필요했습니다.",
    approach: "Java Spring 백엔드, Angular 프론트엔드, Python 기반 분석으로 AI 시각화 도구 대시보드를 개발하여, 모델 결과를 인터랙티브 차트로 제공했습니다.",
    outcome: "대시보드가 KISA 정부 프로젝트에 제공되어, 이해관계자가 AI 기반 분석을 직접 확인할 수 있게 되었습니다.",
  },
  "daeduk-pd": {
    title: "대덕 예지보전 엔진",
    category: "스마트 팩토리 & ML",
    description: "대덕전자를 위한 설비 예지보전 플랫폼을 구축했습니다: 진동 센서가 기계 소음을 수집하고, Hortonworks 빅데이터 플랫폼이 저장·처리하며, TensorFlow RMSE 모델이 이상 진동을 감지해 공장 대시보드에 실시간 알림을 보냅니다.",
    challenge: "대덕전자는 공장 현장에서 설비 고장 예측 분석이 필요했습니다 — 예상치 못한 기계 고장이 계획되지 않은 다운타임과 값비싼 긴급 수리를 유발했고, 기계가 고장으로 향하고 있다는 조기 경고 신호가 없었습니다.",
    approach: "진동 센서를 설비에 부착해 운전 소음을 지속적으로 수집하고, Hortonworks 빅데이터 플랫폼으로 스트리밍해 저장·처리했습니다. Java Spring과 Angular 프론트엔드로 애플리케이션을 구축하고, TensorFlow RMSE 모델을 학습시켜 각 기계의 정상 진동 패턴을 학습하고 평소 운전 평균에서 벗어나는 소리를 감지했습니다.",
    outcome: "진동이 정상 평균에서 벗어나면 시스템이 이상을 감지하고 공장 대시보드에 실시간 알림을 보냅니다 — 현장 직원이 경고를 보고 고장 전에 정비를 계획할 수 있어, 대덕전자가 사후 수리에서 예지보전으로 전환했습니다.",
  },
  "hyundai-cv": {
    title: "현대 컴퓨터 비전 암석 감지",
    category: "컴퓨터 비전",
    description: "충주 음식물 바이오에너지센터 — 하루 80톤의 음식물 쓰레기를 바이오 메탄 연료로 전환하는 현대건설 시설 — 를 위한 컴퓨터 비전 암석 감지 애플리케이션을 TensorFlow Mask R-CNN 모델로 개발했습니다.",
    challenge: "현대건설이 하루 80톤의 음식물 쓰레기를 차량 연료 및 도시가스용 바이오 메탄으로 전환하기 위해 건설한 충주 음식물 바이오에너지센터는 처리 구역의 암석·이물질 자동 감지가 필요했습니다. 수동 검사는 느리고 일관성이 없었습니다.",
    approach: "Java Spring, Angular, Python으로 컴퓨터 비전 애플리케이션을 개발하고, 카메라 피드에서 암석을 픽셀 단위로 분할하는 TensorFlow Mask R-CNN 모델을 학습시켰습니다.",
    outcome: "시스템이 바이오센터의 암석 감지를 자동화하여, 응용 딥러닝으로 안전성과 검사 일관성을 개선했습니다.",
  },
};
